import React, { forwardRef } from "react";
import styles from "./Text.module.scss";
//import strings from "assets/strings";

interface TextProps {
  children?: React.ReactNode;
  useHighLight?: boolean;
  text: string | React.ReactNode;
  text2?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  labelFor?: string;
  isLegend?: boolean;
  isModalTitle?: boolean;
  ariaLabel?: string;
  isBtnDisabled?: boolean;
  // Add any other props that might be needed
}

const Text = forwardRef<HTMLButtonElement | HTMLLegendElement | HTMLLabelElement, TextProps>(({
  children,
  useHighLight,
  text,
  text2,
  className,
  style,
  onClick,
  labelFor,
  isLegend,
  isModalTitle,
  ariaLabel,
  isBtnDisabled,
  ...props
}, ref) => {
  if (onClick) {
    return (
      <button
      disabled={isBtnDisabled}
        style={style}
        onClick={onClick}
        className={styles.button}
        type="button"
        //aria-label={`${strings.globalStrings.toList} ${ariaLabel}`}
        aria-label={`${ariaLabel}`}
        ref={ref as React.RefObject<HTMLButtonElement>}
      >
        <span className={className ? className : styles.p} style={style}>
          {useHighLight && children}
          {!useHighLight && text}
        </span>
      </button>
    );
  }

  if (isLegend) {
    return (
      <legend
        className={className ? className : styles.p}
        style={style}
        {...props}
        ref={ref as React.RefObject<HTMLLegendElement>}
      >
        {!useHighLight && text}
        {useHighLight && children}
        {text2 && (
          <>
            <br />
            {text2}
          </>
        )}
      </legend>
    );
  }

  return (
    <label
      title={typeof text === 'string' ? text : undefined}
      id={isModalTitle ? `modalTitle` : undefined}
      className={className ? className : styles.p}
      style={style}
      {...props}
      htmlFor={labelFor}
      ref={ref as React.RefObject<HTMLLabelElement>}
    >
      {!useHighLight && text}
      {useHighLight && children}
      {text2 && (
        <>
          <br />
          {text2}
        </>
      )}
    </label>
  );
});

export default Text;
